export default __webpack_public_path__ + "static/media/Kiwa_ISO_9001.627d8608.jpeg";